export default __webpack_public_path__ + "static/media/Harsiddhi-Temple.6c4508a1.jpg";